<template>
  <a-collapse :bordered="false" v-model="key">
    <a-collapse-panel :showArrow="false" key="1">
      <h3 slot="header" style="border-left:2px solid #00a2eb;padding-left:20px">求职动机</h3>
      <p>1、谋求个人发展，追求晋升空间：期望转换进入更理想行业，晋升为管理者岗位；</p>
      <p>2、进入行业内领先企业，创业初期的企业或井喷式企业；</p>
      <p>3、期望寻找工作职权更大，管理幅度更大的职位；</p>
    </a-collapse-panel>
    <a-collapse-panel :showArrow="false" key="2">
      <h3 slot="header" style="border-left:2px solid #00a2eb;padding-left:20px">推荐理由</h3>
      <p>1、候选人有本岗位直接相关工作经验，或虽然无直接相关的工作经验，但是拥有本岗位所需的胜任力</p>
      <p>2、候选人软性素质与客户要求匹配度高</p>
    </a-collapse-panel>
    <a-collapse-panel :showArrow="false" key="3">
      <h3 slot="header" style="border-left:2px solid #00a2eb;padding-left:20px">沟通记录</h3>
      <a-list itemLayout="vertical">
        <a-list-item>
          <a-list-item-meta title="来自猎头的沟通" description="添加时间：2019-05-31 12:23:56"></a-list-item-meta>
          <div>6年公关，8年整合营销，3年项目运营，1年基金投资，1年跨界经营，从IT到（移动）互联网，创业公司和美国上市公司；  2009.1作为中国城市广播联盟奥运报道中心编辑和活动策划参与了奥运报道工作和获奖节目的制作。</div>
        </a-list-item>
        <a-list-item>
          <a-list-item-meta title="来自HR的沟通" description="添加时间：2019-05-31 12:23:56"></a-list-item-meta>
          <div>6年公关，8年整合营销，3年项目运营，1年基金投资，1年跨界经营，从IT到（移动）互联网，创业公司和美国上市公司；  2009.1作为中国城市广播联盟奥运报道中心编辑和活动策划参与了奥运报道工作和获奖节目的制作。</div>
        </a-list-item>
      </a-list>
    </a-collapse-panel>
    <a-collapse-panel :showArrow="false" key="4">
      <h3 slot="header" style="border-left:2px solid #00a2eb;padding-left:20px">软性点评</h3>
      <a-list itemLayout="vertical">
        <a-list-item>
          <a-list-item-meta title="Jennifer Yang" description="添加时间：2019-05-31 12:23:56"></a-list-item-meta>
          <a-row>
            <a-col span="12">
              <p><b>软性点评</b></p>
              <div>自信度：非常自信</div>
              <div>沟通能力：善于表达</div>
              <div>形象管理：洋气/高大上/注重形象</div>
            </a-col>
            <a-col span="12">
              <p><b>极端软性点评</b></p>
              <a-button type="primary" style="border-radius: 20px;margin-right:10px;" size="small"> 斜眼</a-button>
              <a-button type="primary" style="border-radius: 20px;margin-right:10px;" size="small">超级近视</a-button>
              <a-button type="primary" style="border-radius: 20px" size="small"> 五官异常</a-button>
            </a-col>
          </a-row>
        </a-list-item>
      </a-list>
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
export default {
  name: "ResumeReportModal",
  data() {
    return {
      key: ['1','2','3','4']
    };
  },
  components: {},
  computed: {},
  created() {},
  methods: {}
};
</script>

<style scoped lang="scss">
</style>
